import { Flex, Heading, Box } from '@chakra-ui/react';
import React from 'react';

import { Maybe } from 'types/dashboard-core-gqlTypes.generated.d';

import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';

import '../../styles/common.scss';

export const StratsTemplate = ({
  children,
  organizationId,
  header,
}: {
  children: React.ReactChild | React.ReactChild[];
  header: string;
  organizationId?: Maybe<string>;
}) => {
  return (
    <>
      <Box id="strats-template-header" background="white" pt="30px" px="10">
        <Flex justify="space-between">
          <Heading as="h2">{header}</Heading>
          <Box>
            <CreditFacilitySelect organizationId={organizationId} />
          </Box>
        </Flex>
      </Box>

      <Box px="10">
        <Box mt="8" id="strats-template-wrapper">
          {children}
        </Box>
      </Box>
    </>
  );
};
